import React from 'react';
import { RightArrowIcon } from '@components/shared/icon/RightArrowIcon';
import { cn } from '@utils/index';

interface LandingButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  href?: string;
  target?: string;
  rel?: string;
  showArrow?: boolean;
  className?: string;
  arrowClassName?: string;
}

// Primary CTA styled after the onboarding form's Next/Prev buttons:
// pill shape, uppercase bold, fixed height, with a right arrow.
export const LandingButton: React.FC<LandingButtonProps> = ({
  children,
  onClick,
  href,
  target,
  rel,
  showArrow = true,
  className,
  arrowClassName,
}) => {
  const classes = cn(
    "group inline-flex items-center justify-center gap-3 rounded-full px-[1em] py-[1em] sm:px-[50px] sm:py-[22px] font-['Inter'] text-[21px] sm:text-[clamp(1rem,34px,44px)] font-light normal-case leading-none text-white transition-opacity hover:opacity-90",
    className
  );
  const style = {
    backgroundColor: 'var(--color-primary, #143b6b)',
    fontFamily: 'Inter, sans-serif',
  };
  const inner = (
    <>
      {children}
      {showArrow && (
        <RightArrowIcon
          color="#fff"
          size={11}
          className={cn(
            'transition-transform group-hover:translate-x-0.5',
            arrowClassName
          )}
        />
      )}
    </>
  );

  if (href) {
    return (
      <a href={href} target={target} rel={rel} className={classes} style={style}>
        {inner}
      </a>
    );
  }
  return (
    <button type="button" onClick={onClick} className={classes} style={style}>
      {inner}
    </button>
  );
};
